import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {GetHealthOpenScheduling} from 'domain/usecases';
import {RemoteGetHealthOpenScheduling} from 'data/usecases';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthOpenScheduling = (): GetHealthOpenScheduling =>
	new RemoteGetHealthOpenScheduling(
		makeBFFApiUrl(BookingFlowEndPoints.healthOpenScheduling),
		makeAuthorizeHttpClientDecorator(),
	);
